import React, { Component, PropTypes } from 'react';
import cn from 'classnames';
import moment from 'moment';
import { Row, Col, Alert, Button, Icon, Table } from 'antd';
import classes from '../styles/order/OrderInfo.module.scss';
import { formatNumber } from 'utils/formatting';
import { Link } from 'react-router';
import TableHelper from 'helpers/Table';
import { dateTh, formatDate } from 'utils/formatDate';
import { get, orderBy } from 'lodash';

const days = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];
const formatTime = (timeNumber) => {
  return moment(`${timeNumber}`, 'Hmm').format('HH:mm');
};
const formatPrice = (number) => {
  return formatNumber(number, '0,0.00');
};

const OrderDetail = ({ revenue, order, onApproveOrder, onCancelOrder, openEditPaymentModal }) => {
  let totalPrice = order.fullPrice;
  let totalPriceIncludeDiscount = order.fullPrice;

  return (
    <div className={cn(classes.orderRevenueContainer)}>
      <Row gutter={12}>
        <Col lg={12} md={24}>
          <div className="content">
            <table>
              <thead>
                <tr className="bold">
                  <td>Description</td>
                  <td className="text-right">Price</td>
                  <td>Qty.</td>
                  <td className="text-right">Total</td>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>ค่าเรียน</td>
                  <td className="text-right">{formatPrice(order.schedule.price)}</td>
                  <td>{order.seats}</td>
                  <td className="text-right">{formatPrice(order.schedule.price * order.seats)}</td>
                </tr>
                {order.additionalList.length > 0 && (
                  <tr>
                    <td className="bold underline">Other Options</td>
                    <td />
                    <td />
                    <td />
                  </tr>
                )}
                {order.additionalList.map((additionalItem) => {
                  totalPrice += additionalItem.amount;
                  totalPriceIncludeDiscount += additionalItem.amount;
                  return (
                    <tr>
                      <td>{additionalItem.type}</td>
                      <td className="text-right">{formatPrice(additionalItem.amount / additionalItem.count)}</td>
                      <td>{additionalItem.count}</td>
                      <td className="text-right">{formatPrice(additionalItem.amount)}</td>
                    </tr>
                  );
                })}
                <tr className="bold-border-top">
                  <td className={'bold'}>Total</td>
                  <td />
                  <td />
                  <td className="text-right">{formatPrice(totalPrice)}</td>
                </tr>
                {order.discountList.length > 0 && (
                  <tr>
                    <td className="bold underline">Discount</td>
                    <td />
                    <td />
                    <td />
                  </tr>
                )}
                {order.discountList.map((discountItem) => {
                  totalPriceIncludeDiscount -= discountItem.amount;
                  let type = discountItem.type;
                  if (type === 'earlybird') {
                    type = 'Early Bird discount';
                  } else {
                    type = 'Special discount';
                  }
                  return (
                    <tr>
                      <td>{type}</td>
                      <td className="text-right" />
                      <td>{type === 'earlybird' ? discountItem.count : ''}</td>
                      <td className="red text-right no-wrap">- {formatPrice(discountItem.amount)}</td>
                    </tr>
                  );
                })}
                <tr className="bold-border-top">
                  <td className={'bold'}>
                    Teacher
                    {"'"}s Revenue
                  </td>
                  <td />
                  <td />
                  <td className="text-right">{formatPrice(totalPriceIncludeDiscount)}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </Col>
        <Col lg={12} md={24}>
          <div className="content">
            <table>
              <thead>
                <tr className="bold">
                  <td>Name</td>

                  <td className={'text-right'}>Total</td>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Processing Fee</td>

                  <td className="text-right">{formatPrice(order.cardFee)}</td>
                </tr>
                {order.promocodeDiscountAmount ? (
                  <tr>
                    <td>Promo Disc</td>

                    {order.promocodeDiscountAmount > 0 ? <td className="red text-right">- {formatPrice(order.promocodeDiscountAmount)}</td> : <td className="text-right">0.00</td>}
                  </tr>
                ) : (
                  <tr />
                )}

                <tr>
                  <td>T-Points</td>
                  {order.points > 0 ? <td className="red text-right">- {formatPrice(order.points)}</td> : <td className="text-right">0.00</td>}
                </tr>

                <tr className="bold-border-top">
                  <td className={'bold'}>Amount Due</td>

                  <td className="text-right">{formatPrice(order.paidPrice)}</td>
                </tr>
              </tbody>
            </table>
          </div>
          {order.paymentMethod === 'transfer' && (
            <div className="content">
              <div className={('text-right', classes.editPaymentBtn)}>
                <Button className={''} onClick={openEditPaymentModal}>
                  <Icon type="pushpin" />
                  Edit Payment
                </Button>
              </div>
              <table>
                <tbody>
                  <tr>
                    <td className="bold">Amount Paid</td>
                    <td className="">{get(order, 'paymentDetail.money') && formatPrice(order.paymentDetail.money)}</td>
                  </tr>
                  <tr>
                    <td className="bold">Payment Date & Time</td>
                    <td className="">{get(order, 'paymentDetail.dateTime') && moment(order.paymentDetail.dateTime).format('DD/MM/YYYY | HH:mm')}</td>
                  </tr>
                  <tr>
                    <td className="bold">Payment Slip</td>
                    <td className="">{get(order, 'paymentDetail.evidence') && <img src={order.paymentDetail.evidence} alt="" />}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          )}
        </Col>
      </Row>

      <div className="content text-center">
        <Row>
          <Col xs={11} className={'text-right'}>
            <Button
              type="danger"
              size="large"
              disabled={order.status === 'rejected' || order.status === 'success'}
              onClick={order.status !== 'rejected' && order.status !== 'success' && onCancelOrder}
            >
              Reject
            </Button>
          </Col>
          <Col xs={2} />

          <Col xs={11} className={'text-left'}>
            <Button
              type="success"
              size="large"
              disabled={order.status === 'rejected' || order.status === 'paid' || order.status === 'success' || (order.status === 'confirm' && get(order, 'schedule.isSummary'))}
              onClick={!(order.status === 'rejected' || order.status === 'paid' || order.status === 'success' || (order.status === 'confirm' && get(order, 'schedule.isSummary'))) && onApproveOrder}
            >
              Approve
            </Button>{' '}
          </Col>
        </Row>
      </div>
    </div>
  );
};

const columns = [
  {
    ...TableHelper.defaultColumn('Code', 'code'),
    render: (value, record) => (
      <div className="no-wrap">
        <Link to={`/order-item/${record._id}`}>{value}</Link>
        {record.remark && <Icon type="pushpin" />}
      </div>
    ),
    sorter: true,
  },

  {
    ...TableHelper.defaultColumn('Teacher', 'teacher'),
    render: (value, record) => (
      <Link to={`/teacher/${get(record, 'class.owner._id')}`}>
        {get(record, 'class.owner.displayName')}
        {/* {get(record, 'class.owner.name.first')} {get(record, 'class.owner.name.last')} */}
      </Link>
    ),
  },
  {
    ...TableHelper.defaultColumn('Class No.', 'class.classCode'),
    render: (value, record) => {
      if (record.rowType === 'Total') return 'Total';
      return <Link to={`/class/${record.class._id}`}>{record.class && record.class.classCode}</Link>;
    },
  },

  {
    ...TableHelper.priceColumn('Price', 'class.price'),
  },
  {
    ...TableHelper.priceColumn('Sp.\nDisc', 'discount'),
    render: (value, record) => <span className="red">{record.fullprice - record.price > 0 ? formatNumber(record.price - record.fullprice, '0,0.00') : '-0.00'}</span>,
  },
  {
    ...TableHelper.priceColumn('Teacher’s\nRev', 'price'),
  },
  {
    ...TableHelper.priceColumn('Net\nCom', 'serviceFee'),
    render: (value, record) => formatNumber(value - record.cardFee, '0,0.00'),
    renderExcel: (value, record) => formatNumber(value - record.cardFee, '0.00'),
  },
  {
    ...TableHelper.priceColumn('Proc.\nFee', 'cardFee'),
  },
  {
    ...TableHelper.integerColumn('%Com', 'feePercentage'),
    render: (value, record) => {
      if (record.rowType === 'Total') return '';
      return `${value}%`;
    },
    renderExcel: (value, record) => {
      return `${value}%`;
    },

    sorter: true,
  },
];

export default OrderDetail;
